import { Link } from 'react-router-dom'
import { styled } from '@linaria/react'
import { minimalVars } from '@ovasabi/ui-minimal/tokens'
import { BasketIcon, ChatIcon } from '../icons'

const Style = {
  Fab: styled(Link)`
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    box-sizing: border-box;
    flex-shrink: 0;
    border-radius: ${minimalVars.radius.pill};
    /* Frosted glass chip with a dark inner stroke + dark border, so the icon
       reads on both the gradient header and cream content as it scrolls. */
    background: var(--chow-glass-light, rgba(255, 255, 255, 0.82));
    backdrop-filter: var(--chow-backdrop-filter, blur(10px) saturate(1.2));
    -webkit-backdrop-filter: var(--chow-backdrop-filter, blur(10px) saturate(1.2));
    border: 1px solid ${minimalVars.color.textPrimary};
    color: ${minimalVars.color.textPrimary};
    text-decoration: none;
    transition: background-color 160ms ease;

    @media (hover: hover) and (pointer: fine) {
      &:hover {
        background: var(--chow-glass-light-hover, rgba(255, 255, 255, 0.95));
      }
    }
    &:focus-visible {
      outline: 2px solid ${minimalVars.color.textPrimary};
      outline-offset: 2px;
    }
  `,
  Count: styled.span`
    position: absolute;
    top: -4px;
    right: -4px;
    min-width: 16px;
    height: 16px;
    padding: 0 4px;
    border-radius: 999px;
    background: ${minimalVars.color.bgSurface};
    color: ${minimalVars.color.brand};
    font-family: ${minimalVars.typography.bodyFamily};
    font-size: 10px;
    font-weight: ${minimalVars.typography.weightBold};
    line-height: 16px;
    text-align: center;
    box-shadow: ${minimalVars.shadow.subtle};
  `,
}

/** Cart shortcut with a capped count, shared by mobile navigation. */
export const CartFab = ({ count, to = '/cart' }: { count: number; to?: string }) => (
  <Style.Fab to={to} aria-label={`Cart, ${count} item${count === 1 ? '' : 's'}`}>
    <BasketIcon size="md" />
    {count > 0 ? <Style.Count>{count > 9 ? '9+' : count}</Style.Count> : null}
  </Style.Fab>
)

export const MessagesFab = ({ count }: { count: number }) => (
  <Style.Fab to="/inbox" aria-label={`Messages, ${count} unread conversation${count === 1 ? '' : 's'}`}>
    <ChatIcon size="md" />
    {count > 0 ? <Style.Count>{count > 99 ? '99+' : count}</Style.Count> : null}
  </Style.Fab>
)
